import Service from "../service";
// ถ้า endpoint ต้องใช้ token ให้เปลี่ยนไปใช้ AuthService แทน:
// import AuthService from "../authService";

const Share = {
  // TODO: อัปเดต endpoint + รูปแบบ payload ให้ตรงกับ API จริงของ backend
  recordShare(payload) {
    return Service.post("/share/record", payload);
  },
};

export default Share;
